import { render, staticRenderFns } from "./UgcSubmissionList.vue?vue&type=template&id=7c3db56a"
import script from "./UgcSubmissionList.vue?vue&type=script&lang=js"
export * from "./UgcSubmissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports